/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum hazmat_override_event_type {
  CREATED = 'created',
  MODIFIED = 'modified',
  REMOVED = 'removed',
}
